// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurrencyModal-errorMessage-e_Cm0 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.CurrencyModal-space1-w0zx6 {
	margin-bottom: 6px !important;
}
.CurrencyModal-space2-u9VSF {
	margin-bottom: 12px !important;
}
.CurrencyModal-space3-PVQwo {
	margin-bottom: 18px !important;
}
.CurrencyModal-space4-sQEPW {
	margin-bottom: 24px !important;
}
.CurrencyModal-space5-LhbvQ {
	margin-bottom: 30px !important;
}
.CurrencyModal-space6-buquI {
	margin-bottom: 36px !important;
}
.CurrencyModal-space7-QlTvs {
	margin-bottom: 42px !important;
}
.CurrencyModal-spaceTop8-Z_34j {
	margin-bottom: 48px !important;
}
.CurrencyModal-spaceTop1-PpeE1 {
	margin-top: 6px !important;
}
.CurrencyModal-spaceTop2-EN1si {
	margin-top: 12px !important;
}
.CurrencyModal-spaceTop3-V3tBB {
	margin-top: 18px !important;
}
.CurrencyModal-spaceTop4-nB4g3 {
	margin-top: 24px !important;
}
.CurrencyModal-spaceTop5-Y_r4S {
	margin-top: 30px !important;
}
.CurrencyModal-spaceTop6-LcYoL {
	margin-top: 36px !important;
}
.CurrencyModal-spaceTop7-ZBYLL {
	margin-top: 42px !important;
}
.CurrencyModal-spaceTop8-Z_34j {
	margin-top: 48px !important;
}
.CurrencyModal-noMargin-G0mNj {
	margin: 0px !important;
}
.CurrencyModal-padding1-QVLyt {
	padding-bottom: 6px !important;
}
.CurrencyModal-padding2-MEMLR {
	padding-bottom: 12px !important;
}
.CurrencyModal-padding3-sxyQF {
	padding-bottom: 18px !important;
}
.CurrencyModal-padding4-cMgP8 {
	padding-bottom: 24px !important;
}
.CurrencyModal-padding5-MvY8B {
	padding-bottom: 30px !important;
}
.CurrencyModal-padding6-OZf8D {
	padding-bottom: 36px !important;
}
.CurrencyModal-padding7-cElSJ {
	padding-bottom: 42px !important;
}
.CurrencyModal-paddingTop1-MmCiY {
	padding-top: 6px !important;
}
.CurrencyModal-paddingTop2-UzaVw {
	padding-top: 12px !important;
}
.CurrencyModal-paddingTop3-G3cdB {
	padding-top: 18px !important;
}
.CurrencyModal-paddingTop4-gUMbA {
	padding-top: 24px !important;
}
.CurrencyModal-paddingTop5-tuBwe {
	padding-top: 30px !important;
}
.CurrencyModal-paddingTop6-LNPW0 {
	padding-top: 36px !important;
}
.CurrencyModal-paddingTop7-SFlkY {
	padding-top: 42px !important;
}
.CurrencyModal-noPadding-zLaHJ {
	padding: 0px !important;
}
.CurrencyModal-textBold-DPFpV {
	font-weight: 500 !important;
}
.CurrencyModal-textBolder-cbz2C {
	font-weight: 700 !important;
}
.CurrencyModal-textNormal-ODAEs {
	font-weight: normal !important;
}
.CurrencyModal-spaceBottom20-BjgXe {
	margin-bottom: 20px;
}
.CurrencyModal-spaceBottom10-MZmaC {
	margin-bottom: 10px;
}
.CurrencyModal-marginNone-c9UBs {
	margin: 0;
}
.CurrencyModal-spaceBottom15-bG_0P {
	margin-bottom: 15px;
}
.CurrencyModal-marginTopNone-WJzV2 {
	margin-top: 0;
}
.CurrencyModal-spaceTop11-fYWaD {
	margin-top: 11px;
}
.CurrencyModal-spaceTop21-_UaUj {
	margin-top: 21px;
}
.CurrencyModal-spaceTop20-yKqeK {
	margin-top: 20px;
}
.CurrencyModal-spaceTop10-Us2LJ {
	margin-top: 10px;
}
/*New Design Text Colors */
.CurrencyModal-textDarkBlue-gZcV1 {
	color: rgb(20, 39, 94) !important;
}
.CurrencyModal-textLightBlue-xhhfg {
	color: rgb(57, 87, 106) !important;
}
.CurrencyModal-textLightSandleGreen-JjG5l {
	color: rgb(76, 86, 41) !important;
}
.CurrencyModal-textLightBrown-Nbkes {
	color: rgb(115, 79, 33) !important;
}
.CurrencyModal-textMediumMaroon-wYoeJ {
	color: rgb(87, 37, 51) !important;
}
.CurrencyModal-textBrown-UXRnF {
	color: rgb(160, 47, 24) !important;
}
.CurrencyModal-textMaroon-dQVxA {
	color: rgb(155, 49, 67) !important;
}
.CurrencyModal-textDarkBrown-FOPTV {
	color: rgb(83, 18, 16) !important;
}
.CurrencyModal-textMediumBrown-CSMQd {
	color: rgb(142, 28, 10) !important;
}
.CurrencyModal-textSkyBlue-erqDv {
	color: rgb(37, 117, 141) !important;
}
.CurrencyModal-textGray-A3Him {
	color: rgb(77, 65, 51) !important;
}
.CurrencyModal-btn-AtS8J,
.CurrencyModal-btn-AtS8J:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 6px 12px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
	background: var(--background-primary) !important;
	color: var(--primary-btn-foreground) !important;
}
.CurrencyModal-btn-AtS8J:hover {
	background: var(--primary-border) !important;
	outline: 0 !important;
}
.CurrencyModal-btnPrimary-Zf6ZX,
.CurrencyModal-btnPrimary-Zf6ZX:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}
.CurrencyModal-btnPrimary-Zf6ZX:hover {
	border-color: var(--primary-bg-hover) !important;
	background-color: var(--primary-bg-hover) !important;
	color: var(--primary-btn-foreground) !important;
}
.CurrencyModal-btnPrimaryBorder-o1TwR,
.CurrencyModal-btnPrimaryBorder-o1TwR:focus {
	border-color: var(--primary-bg) !important;
	color: var(--primary-bg) !important;
	background-color: var(--background-primary) !important;
}
.CurrencyModal-btnPrimaryBorder-o1TwR:hover {
	border-color: var(--primary-bg-hover) !important;
	color: var(--primary-bg-hover) !important;
	background-color: var(--background-primary) !important;
}
.CurrencyModal-btnLink-m8ze2,
.CurrencyModal-btnLink-m8ze2:focus,
.CurrencyModal-btnLink-m8ze2:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.CurrencyModal-searchFilterPopover-UIsl3 {
	position: absolute;
	top: 51px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	max-height: 65vh;
	visibility: visible;
	background: var(--background-primary);
	-webkit-box-shadow: 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: 0px 0px 10px var(--primary-box-shadow);
	border-radius: 14px;
}
.CurrencyModal-searchFilterPopoverFull-JSwew {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background-color: var(--modal-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.CurrencyModal-searchFilterPopoverOverlay-rsDkV {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	visibility: visible;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
}
.CurrencyModal-dateFilterpopVerlayHeight-oUHgs {
	max-height: 100%;
}
.CurrencyModal-dateFilterpopVerlayContentHeight-vdWMd {
	min-height: 100% !important;
}
.CurrencyModal-searchFilterCloseIcon-LqMJ3 {
	font-size: 30px;
	color: var(--secondary-foreground);
}
.CurrencyModal-searchFilterPopoverFooter-IIa0i {
	width: 100%;
	position: relative;
	line-height: 0;
}
.CurrencyModal-displayTable-yOMFY {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.CurrencyModal-displayTableRow-k1OV4 {
	display: table-row;
	vertical-align: middle;
}
.CurrencyModal-displayTableCell-ZaVAe {
	display: table-cell;
	vertical-align: middle;
}
.CurrencyModal-displayInlineBlock-p5F0v {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.CurrencyModal-fullWidth-XsVmj {
	width: 100% !important;
}
.CurrencyModal-captionTitle-_JGnW {
	font-size: 16px;
	color: var(--primary-foreground);
}
.CurrencyModal-showTabletSection-V7VOb {
	display: none !important;
}
.CurrencyModal-blockRadioButton-uV0ig {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}
.CurrencyModal-jumboSelect-g2r1a {
	height: 58px !important;
	font-size: 16px !important;
	padding: 15px 47px 20px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
}
.CurrencyModal-jumboSelectPadding-oPCoR {
	padding: 15px 50px 20px 20px !important;
}
.CurrencyModal-commonBorder-yCaBY {
	border: 1px solid var(--primary-border) !important;
	color: var(--secondary-foreground) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 3px !important;
}
.CurrencyModal-textAignRight-fSNwN {
	text-align: right;
}
.CurrencyModal-textAlignLeft-WXVBx {
	text-align: left;
}
.CurrencyModal-textAignCenter-XkoEE {
	text-align: center;
}
.CurrencyModal-moreFilterTitle-dPHh5 {
	font-size: 18px;
}
.CurrencyModal-dot-kfttP {
	color: var(--secondary-foreground);
	font-size: 12px;
	margin-bottom: 0;
}
/*************************** Header Modal Start **********************/
.CurrencyModal-currencyAndLanguageGrid-Yk3VK {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 30px;
}
.CurrencyModal-activeItem-ItWwu {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 8px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
}
.CurrencyModal-activeItem-ItWwu:hover,
.CurrencyModal-activeItem-ItWwu:focus,
.CurrencyModal-activeItem-ItWwu:active {
	background-color: var(--common-hover-bg);
	color: var(--primary-foreground);
}
.CurrencyModal-activeSection-oX9g9:first-child {
	background-color: var(--primary-gray-bg);
	color: var(--primary-foreground);
	border: 1px solid var(--secondary-bg);
	cursor: not-allowed;
}
.CurrencyModal-commonCloseModalBtn-Qrb6K {
	position: absolute;
	cursor: pointer;
}
.CurrencyModal-searchIconCommon-KoeAJ {
	margin-right: 3px;
	position: relative;
	top: -1px;
}
.CurrencyModal-loginLabel-dpD1k {
	font-size: 16px;
	margin-bottom: 10px;
	font-weight: 600;
}
@media screen and (max-width: 767px) {

	.CurrencyModal-dropdownOverflow-xY_KE {
		white-space: break-spaces;
		text-align: left;
	}

	.CurrencyModal-currencyAndLanguageGrid-Yk3VK {
		grid-template-columns: repeat(2, 1fr);
	}
}
@media (max-width:991px) and (min-width:768px) {
	.CurrencyModal-currencyAndLanguageGrid-Yk3VK {
		grid-template-columns: repeat(4, 1fr);
	}
}
/*************************** Header Modal End **********************/
.CurrencyModal-capitalizeText-o5UTc {
	text-transform: capitalize;
}
@media screen and (max-width: 767px) {
	.CurrencyModal-searchFilterPopoverHeader-RVb4q {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 24px;
		border-bottom: 1px solid var(--primary-border);
		background-color: var(--modal-bg);
		border-radius: 14px 14px 0 0;
	}
}
@media screen and (max-width: 768px) {
	.CurrencyModal-searchFilterPopoverFull-JSwew {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		border-radius: 14px;
	}

	.CurrencyModal-searchFilterPopoverContent-O7Ga4 {
		height: 100%;
		min-height: 100vh;
		-webkit-overflow-scrolling: touch;
	}

	.CurrencyModal-showTabletSection-V7VOb {
		display: block !important;
	}

	.CurrencyModal-hideTabletSection-UeD7g {
		display: none !important;
	}
}
@media screen and (max-width: 767px) {
	.CurrencyModal-searchFilterPopoverFooter-IIa0i {
		position: relative !important;
	}
}
@media screen and (max-width: 350px) {
	.CurrencyModal-btnFontsize-GMXqv {
		font-size: 14px !important;
	}
}
@media (max-width: 360px) {
	.CurrencyModal-searchFilterCloseIcon-LqMJ3 {
		font-size: 25px;
	}
}
@media (max-width: 993px) and (min-width: 769px) {
	.CurrencyModal-responsiveFontsize-eEJeK {
		font-size: 14px;
	}
}
/*****************Apply Button Alignment Start **********************/
.CurrencyModal-applyBtnDesktop-vmHJ3 {
	text-align: right;
}
@media screen and (max-width: 991px) {
	.CurrencyModal-applyBtnDesktop-vmHJ3 {
		text-align: center;
	}

	.CurrencyModal-applyBtnDesktopRight-Yrruo {
		text-align: right !important;
	}

	.CurrencyModal-applyBtnDesktopNoPaddingRight-RNRTC {
		padding-right: 0px !important;
	}

}
/*****************Apply Button Alignment Start **********************/`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,gDAAgD;CAChD,+CAA+C;AAChD;AAEA;CACC,4CAA4C;CAC5C,qBAAqB;AACtB;AAEA;;CAEC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;AAChD;AAEA;CACC,gDAAgD;CAChD,oDAAoD;CACpD,+CAA+C;AAChD;AAEA;;CAEC,0CAA0C;CAC1C,mCAAmC;CACnC,sDAAsD;AACvD;AAEA;CACC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;AAEA;;;CAGC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;CACrC,0DAAkD;SAAlD,kDAAkD;CAClD,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,SAAS;CACT,iCAAiC;AAClC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,uCAAuC;CACvC,kDAAkD;CAClD,6BAA6B;AAC9B;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,kDAAkD;CAClD,6CAA6C;CAC7C,mCAA2B;SAA3B,2BAA2B;CAC3B,6BAA6B;AAC9B;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;AAEA,sEAAsE;AACtE;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;AAGA;;;CAGC,wCAAwC;CACxC,gCAAgC;AACjC;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,qCAAqC;CACrC,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;;CAEC;EACC,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,qCAAqC;CACtC;AACD;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;AAEpE;CACC,0BAA0B;AAC3B;AAEA;CACC;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;CAC7B;AACD;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;CAClC;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;AAED;AAEA,qEAAqE","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 6px 12px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btn:hover {\n\tbackground: var(--primary-border) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tbackground-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-bg) !important;\n\tcolor: var(--primary-bg) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-bg-hover) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnLink,\n.btnLink:focus,\n.btnLink:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 51px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tmax-height: 65vh;\n\tvisibility: visible;\n\tbackground: var(--background-primary);\n\tbox-shadow: 0px 0px 10px var(--primary-box-shadow);\n\tborder-radius: 14px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground-color: var(--modal-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tvisibility: visible;\n\tbottom: 0;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.dateFilterpopVerlayHeight {\n\tmax-height: 100%;\n}\n\n.dateFilterpopVerlayContentHeight {\n\tmin-height: 100% !important;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--secondary-foreground);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.jumboSelect {\n\theight: 58px !important;\n\tfont-size: 16px !important;\n\tpadding: 15px 47px 20px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n}\n\n.jumboSelectPadding {\n\tpadding: 15px 50px 20px 20px !important;\n}\n\n.commonBorder {\n\tborder: 1px solid var(--primary-border) !important;\n\tcolor: var(--secondary-foreground) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n}\n\n.textAignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAignCenter {\n\ttext-align: center;\n}\n\n.moreFilterTitle {\n\tfont-size: 18px;\n}\n\n.dot {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 12px;\n\tmargin-bottom: 0;\n}\n\n/*************************** Header Modal Start **********************/\n.currencyAndLanguageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 30px;\n}\n\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n}\n\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-hover-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--primary-gray-bg);\n\tcolor: var(--primary-foreground);\n\tborder: 1px solid var(--secondary-bg);\n\tcursor: not-allowed;\n}\n\n.commonCloseModalBtn {\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.searchIconCommon {\n\tmargin-right: 3px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.loginLabel {\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n\tfont-weight: 600;\n}\n\n@media screen and (max-width: 767px) {\n\n\t.dropdownOverflow {\n\t\twhite-space: break-spaces;\n\t\ttext-align: left;\n\t}\n\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media (max-width:991px) and (min-width:768px) {\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tbackground-color: var(--modal-bg);\n\t\tborder-radius: 14px 14px 0 0;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tborder-radius: 14px;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\theight: 100%;\n\t\tmin-height: 100vh;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 14px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n@media (max-width: 993px) and (min-width: 769px) {\n\t.responsiveFontsize {\n\t\tfont-size: 14px;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n\n}\n\n/*****************Apply Button Alignment Start **********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `CurrencyModal-errorMessage-e_Cm0`,
	"space1": `CurrencyModal-space1-w0zx6`,
	"space2": `CurrencyModal-space2-u9VSF`,
	"space3": `CurrencyModal-space3-PVQwo`,
	"space4": `CurrencyModal-space4-sQEPW`,
	"space5": `CurrencyModal-space5-LhbvQ`,
	"space6": `CurrencyModal-space6-buquI`,
	"space7": `CurrencyModal-space7-QlTvs`,
	"spaceTop8": `CurrencyModal-spaceTop8-Z_34j`,
	"spaceTop1": `CurrencyModal-spaceTop1-PpeE1`,
	"spaceTop2": `CurrencyModal-spaceTop2-EN1si`,
	"spaceTop3": `CurrencyModal-spaceTop3-V3tBB`,
	"spaceTop4": `CurrencyModal-spaceTop4-nB4g3`,
	"spaceTop5": `CurrencyModal-spaceTop5-Y_r4S`,
	"spaceTop6": `CurrencyModal-spaceTop6-LcYoL`,
	"spaceTop7": `CurrencyModal-spaceTop7-ZBYLL`,
	"noMargin": `CurrencyModal-noMargin-G0mNj`,
	"padding1": `CurrencyModal-padding1-QVLyt`,
	"padding2": `CurrencyModal-padding2-MEMLR`,
	"padding3": `CurrencyModal-padding3-sxyQF`,
	"padding4": `CurrencyModal-padding4-cMgP8`,
	"padding5": `CurrencyModal-padding5-MvY8B`,
	"padding6": `CurrencyModal-padding6-OZf8D`,
	"padding7": `CurrencyModal-padding7-cElSJ`,
	"paddingTop1": `CurrencyModal-paddingTop1-MmCiY`,
	"paddingTop2": `CurrencyModal-paddingTop2-UzaVw`,
	"paddingTop3": `CurrencyModal-paddingTop3-G3cdB`,
	"paddingTop4": `CurrencyModal-paddingTop4-gUMbA`,
	"paddingTop5": `CurrencyModal-paddingTop5-tuBwe`,
	"paddingTop6": `CurrencyModal-paddingTop6-LNPW0`,
	"paddingTop7": `CurrencyModal-paddingTop7-SFlkY`,
	"noPadding": `CurrencyModal-noPadding-zLaHJ`,
	"textBold": `CurrencyModal-textBold-DPFpV`,
	"textBolder": `CurrencyModal-textBolder-cbz2C`,
	"textNormal": `CurrencyModal-textNormal-ODAEs`,
	"spaceBottom20": `CurrencyModal-spaceBottom20-BjgXe`,
	"spaceBottom10": `CurrencyModal-spaceBottom10-MZmaC`,
	"marginNone": `CurrencyModal-marginNone-c9UBs`,
	"spaceBottom15": `CurrencyModal-spaceBottom15-bG_0P`,
	"marginTopNone": `CurrencyModal-marginTopNone-WJzV2`,
	"spaceTop11": `CurrencyModal-spaceTop11-fYWaD`,
	"spaceTop21": `CurrencyModal-spaceTop21-_UaUj`,
	"spaceTop20": `CurrencyModal-spaceTop20-yKqeK`,
	"spaceTop10": `CurrencyModal-spaceTop10-Us2LJ`,
	"textDarkBlue": `CurrencyModal-textDarkBlue-gZcV1`,
	"textLightBlue": `CurrencyModal-textLightBlue-xhhfg`,
	"textLightSandleGreen": `CurrencyModal-textLightSandleGreen-JjG5l`,
	"textLightBrown": `CurrencyModal-textLightBrown-Nbkes`,
	"textMediumMaroon": `CurrencyModal-textMediumMaroon-wYoeJ`,
	"textBrown": `CurrencyModal-textBrown-UXRnF`,
	"textMaroon": `CurrencyModal-textMaroon-dQVxA`,
	"textDarkBrown": `CurrencyModal-textDarkBrown-FOPTV`,
	"textMediumBrown": `CurrencyModal-textMediumBrown-CSMQd`,
	"textSkyBlue": `CurrencyModal-textSkyBlue-erqDv`,
	"textGray": `CurrencyModal-textGray-A3Him`,
	"btn": `CurrencyModal-btn-AtS8J`,
	"btnPrimary": `CurrencyModal-btnPrimary-Zf6ZX`,
	"btnPrimaryBorder": `CurrencyModal-btnPrimaryBorder-o1TwR`,
	"btnLink": `CurrencyModal-btnLink-m8ze2`,
	"searchFilterPopover": `CurrencyModal-searchFilterPopover-UIsl3`,
	"searchFilterPopoverFull": `CurrencyModal-searchFilterPopoverFull-JSwew`,
	"searchFilterPopoverOverlay": `CurrencyModal-searchFilterPopoverOverlay-rsDkV`,
	"dateFilterpopVerlayHeight": `CurrencyModal-dateFilterpopVerlayHeight-oUHgs`,
	"dateFilterpopVerlayContentHeight": `CurrencyModal-dateFilterpopVerlayContentHeight-vdWMd`,
	"searchFilterCloseIcon": `CurrencyModal-searchFilterCloseIcon-LqMJ3`,
	"searchFilterPopoverFooter": `CurrencyModal-searchFilterPopoverFooter-IIa0i`,
	"displayTable": `CurrencyModal-displayTable-yOMFY`,
	"displayTableRow": `CurrencyModal-displayTableRow-k1OV4`,
	"displayTableCell": `CurrencyModal-displayTableCell-ZaVAe`,
	"displayInlineBlock": `CurrencyModal-displayInlineBlock-p5F0v`,
	"fullWidth": `CurrencyModal-fullWidth-XsVmj`,
	"captionTitle": `CurrencyModal-captionTitle-_JGnW`,
	"showTabletSection": `CurrencyModal-showTabletSection-V7VOb`,
	"blockRadioButton": `CurrencyModal-blockRadioButton-uV0ig`,
	"jumboSelect": `CurrencyModal-jumboSelect-g2r1a`,
	"jumboSelectPadding": `CurrencyModal-jumboSelectPadding-oPCoR`,
	"commonBorder": `CurrencyModal-commonBorder-yCaBY`,
	"textAignRight": `CurrencyModal-textAignRight-fSNwN`,
	"textAlignLeft": `CurrencyModal-textAlignLeft-WXVBx`,
	"textAignCenter": `CurrencyModal-textAignCenter-XkoEE`,
	"moreFilterTitle": `CurrencyModal-moreFilterTitle-dPHh5`,
	"dot": `CurrencyModal-dot-kfttP`,
	"currencyAndLanguageGrid": `CurrencyModal-currencyAndLanguageGrid-Yk3VK`,
	"activeItem": `CurrencyModal-activeItem-ItWwu`,
	"activeSection": `CurrencyModal-activeSection-oX9g9`,
	"commonCloseModalBtn": `CurrencyModal-commonCloseModalBtn-Qrb6K`,
	"searchIconCommon": `CurrencyModal-searchIconCommon-KoeAJ`,
	"loginLabel": `CurrencyModal-loginLabel-dpD1k`,
	"dropdownOverflow": `CurrencyModal-dropdownOverflow-xY_KE`,
	"capitalizeText": `CurrencyModal-capitalizeText-o5UTc`,
	"searchFilterPopoverHeader": `CurrencyModal-searchFilterPopoverHeader-RVb4q`,
	"searchFilterPopoverContent": `CurrencyModal-searchFilterPopoverContent-O7Ga4`,
	"hideTabletSection": `CurrencyModal-hideTabletSection-UeD7g`,
	"btnFontsize": `CurrencyModal-btnFontsize-GMXqv`,
	"responsiveFontsize": `CurrencyModal-responsiveFontsize-eEJeK`,
	"applyBtnDesktop": `CurrencyModal-applyBtnDesktop-vmHJ3`,
	"applyBtnDesktopRight": `CurrencyModal-applyBtnDesktopRight-Yrruo`,
	"applyBtnDesktopNoPaddingRight": `CurrencyModal-applyBtnDesktopNoPaddingRight-RNRTC`
};
module.exports = ___CSS_LOADER_EXPORT___;
